module.exports = __webpack_public_path__ + "static/media/Tablet-inbox-2.1a5a7633.jpg";